export const environment = {
  production: false,
  useMocks: false,
  bypassLoginDev: false,
  adminApiUrl: 'https://api-dhats-hub.deltaprotect.dev/api/admin/graphql',
  clientApiUrl: 'https://api-dhats-hub.deltaprotect.dev/api/client/graphql',
  googleClientId: '590047079602-r2qgj21fksng9soj6avffgjom3mrtatb.apps.googleusercontent.com',
};
